export { default as getCollectionName } from './getCollectionName';
